import { Environments } from '@/config';
import { UHN_PRODUCTION } from './uhn.production';
import { UHN_STAGING } from './uhn.staging';

export const UHN = import.meta.env.MODE === Environments.PROD ? UHN_PRODUCTION : UHN_STAGING;
